import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from "@angular/core";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { MatAccordion } from "@angular/material/expansion";
import { Subject, filter, map } from "rxjs";
import { IActor } from "../../../../../dto-map/i-actor";
import { RemoteSplugParametersConfigurationService } from "../../../../../remotes/remote-splug-parameters-configuration.service";
import { SignProcessWizardService } from "../../../../../sign-process-wizard.service";
import { ActorSplugInfoDialogService } from "../actor-splug-info-dialog.service";
import { ActorSplugInfoService } from "./actor-splug-info.service";

export interface IActorSplugDialogData {

  signProcessWizardService: SignProcessWizardService,
  remoteSplugParametersConfigurationService: RemoteSplugParametersConfigurationService,
  actorId: string,
  actor: IActor,
  actorSplugInfoDialogService: ActorSplugInfoDialogService

}

@Component({
  selector: 'ss-actor-splug-info',
  templateUrl: './actor-splug-info.component.html',
  styleUrls: ['./actor-splug-info.component.scss'],
  host: {
    class: 'flex-column gap-small full-width'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActorSplugInfoComponent implements OnInit {

  private readonly _destroy = new Subject<void>();

  @ViewChild('accordion')
  private _accordion: MatAccordion

  readonly accordionSubject = this._actorSplugInfoService.accordionSubject;
  readonly splugParametersConfigurationsSubject = this._actorSplugInfoService.splugParametersConfigurationsSubject
  get splugParametersConfigurations() {
    return this.splugParametersConfigurationsSubject.value
  }

  readonly splugFormGroup = this._actorSplugInfoService.splugFormGroup;
  readonly splugDefinitionsSubject = this._actorSplugInfoService.splugDefinitionsSubject;
  readonly splugDefinitionsWithActionParamsObs = this.splugDefinitionsSubject.pipe(
    filter(Boolean),
    map((splugDefinitions) => splugDefinitions.filter(({ controls }) => Boolean(controls)))
  )



  readonly validationResultSubject = this._actorSplugInfoService.validationResultSubject;
  readonly validSplugsObs = this._actorSplugInfoService.validSplugsObs;
  readonly selectedSplugsSubject = this._actorSplugInfoService.selectedSplugsSubject;
  get selectedSplugs() {
    return this.selectedSplugsSubject.value
  }
  get actorId() {
    return this._actorSplugInfoService.actorId;
  }

  readonly errorSplugObs = this.validationResultSubject.pipe(
    filter(Boolean),
    map((validationResult) => Object.entries(validationResult).filter(([_, { status }]) => status !== 'OK')),
    map((invalidResults) => invalidResults.reduce<{ [splugId: string]: boolean }>((total, [splugId]) => ({ ...total, [splugId]: true }), {}))
  )


  constructor(
    private readonly _actorSplugInfoService: ActorSplugInfoService
  ) {

  }

  ngOnInit(): void {

  }

  ngAfterViewInit() {

    this.accordionSubject.next(this._accordion);

  }

  toggleSelectedSplug(event: MatCheckboxChange, splugId: string) {
    const checked = event.checked;

    if (checked) {
      this._actorSplugInfoService.selectSplug(splugId)
      return
    }

    this._actorSplugInfoService.deselectSplug(splugId);
  }


}
